module.exports = __webpack_public_path__ + "img/facts-all_1984.f38bc238.png";